import { getToken } from "firebase/messaging";
import { useCallback, useEffect, useRef } from "react";
import { messaging } from "../../config/firebaseConfig";
import { useFormData } from "../../helpers/FormDataProvider";
import NotificationAlert from "./NotificationAlert";
import useFBOApi from "../../services/api/useFBOApi";
import { NOTIFICATION_PERMISSIONS, ENVIRONMENT } from "../../utils/constants";

const NotificationHandler = () => {
  const { userData } = useFormData();
  const { addDeviceToken } = useFBOApi();
  const initializationAttempted = useRef(false);

  const initializeNotifications = useCallback(async () => {
    if (initializationAttempted.current) return;
    initializationAttempted.current = true;

    try {
      if (!messaging) {
        console.warn("Firebase Cloud Messaging is not available");
        return;
      }
      let permission = Notification.permission;

      if (permission === NOTIFICATION_PERMISSIONS.DEFAULT) {
        permission = await Notification.requestPermission();
      }

      if (permission === NOTIFICATION_PERMISSIONS.GRANTED) {
        let token;
        if (process.env.NODE_ENV === ENVIRONMENT.PRODUCTION) {
          token = await getToken(messaging, {
            vapidKey: `REACT_APP_VAPID_KEY_PLACEHOLDER`,
          });
        } else {
          token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_VAPID_KEY,
          });
        }

        try {
          await addDeviceToken(token);
        } catch (error) {
          console.error("Error registering device token:", error);
        }
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  }, [addDeviceToken]);

  useEffect(() => {
    const runInitialization = async () => {
      if (userData?.id &&
        userData?.id !== "" &&
        !initializationAttempted.current) {
        await initializeNotifications();
      }
    };
    runInitialization();
  }, [userData?.id, initializeNotifications]);

  return <NotificationAlert />;
};

export default NotificationHandler;
